@use '@design/design-tokens/typography/typography' as *;

.listTitle {
  @include typography-v2-title-xs;

  color: var(--text-soft);
  padding: 24px 8px 8px;

  &.secondary {
    padding-top: 8px;
    padding-bottom: 0;
  }
}

.titleAndDividerWrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  border: none;
  background: none;
  outline: none;
}

.horizontalDivider {
  position: relative;
  left: -8px;
  margin-right: -16px;
  height: 1px;
  background-color: var(--border-soft);
  margin-top: 4px;
  margin-bottom: 8px;
}

.hideOrShowButtonWrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
}

.skeletonLoaderWrapper {
  margin: 20px 0;
}
